// extracted by mini-css-extract-plugin
module.exports = {"coronaUpdate":"corona_coronaUpdate__1fxLr"};